/* Stage Shop — size chart unit toggle */
(function () {

  function toIn(cm) {
    return Math.round(parseFloat(cm) / 2.54);
  }

  document.addEventListener('change', function (e) {
    if (e.target.type !== 'checkbox') return;

    var root = e.target.closest('[data-size-chart]');
    if (!root) return;

    var isCm  = e.target.checked;
    var table = root.querySelector('table');
    if (!table) return;

    root.querySelectorAll('.sc-unit-lbl').forEach(function (lbl) {
      var isIn = lbl.textContent.trim() === 'IN';
      lbl.classList.toggle('sc-unit-lbl--on', isCm ? !isIn : isIn);
    });

    table.querySelectorAll('.sc-unit').forEach(function (el) {
      el.textContent = isCm ? '(cm)' : '(in)';
    });

    table.querySelectorAll('.mv').forEach(function (cell) {
      var lo = cell.getAttribute('data-lo');
      var hi = cell.getAttribute('data-hi');
      cell.textContent = isCm
        ? lo + '\u2013' + hi
        : toIn(lo) + '\u2013' + toIn(hi);
    });
  });

}());

/* Open studio hire in new tab */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.site-nav__dropdown a[href*="studio50"]').forEach(function (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  });
}());
/* Stage Shop — TSS inventory status message (PDP + Quick View) */
(function () {

  var svgCheck = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-in-stock" viewBox="0 0 12 10"><path fill-rule="evenodd" clip-rule="evenodd" d="m3.293 9.707-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z" fill="#212B36"></path></svg>';

  var svgClock = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-clock" viewBox="0 0 12 12" fill="none" stroke="#212B36" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="5"/><path d="M6 3.5V6l1.75 1.75"/></svg>';

  function isOrderable(inv) {
    return inv &&
      inv.inventory_management === 'shopify' &&
      inv.inventory_policy === 'continue' &&
      inv.inventory_quantity <= 0;
  }

  function renderMessage(msgEl, inventory, variantId) {
    if (!msgEl) return;

    var inv = inventory.find(function (v) { return v.id === variantId; });
    var shipWindow = msgEl.getAttribute('data-ship-window') || '2-4';
    var madeToOrder = msgEl.getAttribute('data-made-to-order') === 'true';

    if (isOrderable(inv)) {
      var orderableText = madeToOrder
        ? '<strong>Made to order</strong> - we\'ll have it made for you. Timing below.'
        : '<strong>Not in stock</strong> - we\'ll order it in for you. Ships in ' + shipWindow + ' business days.';
      msgEl.innerHTML =
        '<div class="store-availability">' + svgClock +
          '<div class="store-availability__info"><div>' + orderableText + '</div></div>' +
        '</div>';
    } else if (inv && inv.inventory_quantity > 0) {
      msgEl.innerHTML =
        '<div class="store-availability">' + svgCheck +
          '<div class="store-availability__info"><div><strong>In stock</strong> - ships within 1 business day.</div></div>' +
        '</div>';
    } else {
      msgEl.innerHTML = '';
    }
  }

  function updateForVariant(variantId) {
    document.querySelectorAll('[data-availability-message]').forEach(function (msgEl) {
      var container = msgEl.closest('[data-section-type="product"]');
      if (!container) return;

      var jsonEl = container.querySelector('[data-variant-inventory-json]');
      if (!jsonEl) return;

      var inventory;
      try { inventory = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      // Only update the message whose product actually owns this variant
      if (inventory.some(function (v) { return v.id === variantId; })) {
        renderMessage(msgEl, inventory, variantId);
      }
    });
  }

  // Impulse dispatches this on the document for every variant change,
  // on the PDP and inside the Quick View popup alike. The initial state
  // is already rendered server-side, so we only need to react to changes.
  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    updateForVariant(variant.id);
  });
}());